<template>
    <div class="w-5 mr-2">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.067 24.51">
            <g id="Account" transform="translate(0.5 0.5)">
                <circle id="Ellipse_2" data-name="Ellipse 2" class="cls-1" cx="5.627" cy="5.627" r="5.627"
                        transform="translate(3.907)"/>
                <path id="Path_14" data-name="Path 14" class="cls-1"
                      d="M44.04,272.284V267.7a5.881,5.881,0,0,0-5.881-5.881H30.854a5.881,5.881,0,0,0-5.881,5.881v4.582"
                      transform="translate(-24.973 -248.274)"/>
            </g>
        </svg>
    </div>
</template>

<script>
export default {
  name: 'AccountIcon',
};
</script>

<style lang="scss" scoped>
    svg {
        fill: none;
        stroke: #464545;
        stroke-miterlimit: 10;

        &:hover {
            stroke: #b21f2d;
        }
    }
</style>
